import React from "react"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import Typography from "@material-ui/core/Typography"
import { IOrgNormalized } from "../interfaces/org-normalized"
import { useOrganisationActions } from "../hooks/use-organisation-actions"
import { debounce } from "lodash"
import { useI18n } from "../../hooks"
import { useAuthUserMembership } from "../../memberships/hooks/use-auth-user-membership"

const OrganisationNameInput = ({ organisation }: OrganisationNameInputProps) => {
  const { translations } = useI18n()
  const { updateOrgName } = useOrganisationActions()
  const inputRef = React.useRef<HTMLInputElement>(null)
  const permissions = useAuthUserMembership()

  const syncOrganisationNameOrRevert = async (newName: string) => {
    if (newName === organisation.name) return

    const updateResult = await updateOrgName(organisation.id, { name: newName })
    if (!updateResult && inputRef.current) {
      inputRef.current.value = organisation.name
    }
  }

  const handleChange = debounce(async (event: React.ChangeEvent<HTMLInputElement>) => {
    await syncOrganisationNameOrRevert(event.target.value)
  }, 500)

  const handleBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
    if (handleChange.cancel) handleChange.cancel()
    await syncOrganisationNameOrRevert(event.target.value)
  }

  return (
    <>
      <Typography
        variant="subtitle1"
        component="label"
        htmlFor="organisation-name-input"
        style={{ display: "inline-block", width: "100%" }}
        gutterBottom
      >
        {translations.orgName || "Organization name"}
        <OutlinedInput
          inputRef={inputRef}
          id="organisation-name-input"
          defaultValue={organisation.name}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={!permissions.canUpdateOrganisationDetails}
          fullWidth
        />
      </Typography>
    </>
  )
}

export default OrganisationNameInput

type OrganisationNameInputProps = {
  organisation: IOrgNormalized
}
